import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';

function fixTotalAmount(amount) {
  let value = amount.toFixed(2).replace('.', ',');
  const index = value.indexOf(',');
  if (index > 3) {
    value = `${value.slice(0, 1)}.${value.slice(1)}`;
  }

  return value;
}

function planLabelOption(type, price, selected, yearlyPriceInstallments) {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="subtitle1" style={{ color: selected && '#537CCD', marginRight: '0.25em' }}>
        {type}
      </Typography>

      <Typography inline variant="caption" style={{ color: selected && '#537CCD' }}>
        {`(R$ ${fixTotalAmount(yearlyPriceInstallments || price)}/mês)`}
        {/* {'R$ 44,90/mês'} */}
      </Typography>

      <Typography inline variant="subtitle1" style={{ marginLeft: '14px', marginRight: '8px', color: selected && '#537CCD', fontWeight: 'bold' }}>
        {`R$ ${fixTotalAmount(price)}`}
      </Typography>
    </div>
  );
}

function PaymentModalContent({ plan, onChange, values }) {
  return (
    <Typography component="div">
      <Typography variant="body1">
      O atendimento via chat será de segunda à sexta, das 08:00 às 18:00 (Horário de Brasília).
        {plan.id === 13 && ' O suporte via videochamada necessita ser agendado.'}
      </Typography>

      <div style={{ marginTop: '20px', marginBottom: '30px' }}>
        <Typography variant="body1" >
          Escolha o melhor para sua empresa:
        </Typography>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px', marginBottom: '10px' }}>
          <div style={{ position: 'relative' }}>
            <FormControlLabel
              control={
                <Radio color="primary" style={{ height: '50px' }} checked={values.planType === 'monthly'} onChange={() => onChange('planType', 'monthly')} value="monthly" />
              }
              label={planLabelOption('Mensal', plan.monthlyPrice, values.planType === 'monthly')}
              style={{
                margin: '0',
                border: '1px solid',
                borderColor: values.planType === 'monthly' ? '#537CCD' : '#CECECE',
              }}
            />
          </div>

          <div style={{ position: 'relative' }}>
            <FormControlLabel
              control={
                <Radio color="primary" style={{ height: '50px' }} checked={values.planType === 'yearly'} onChange={() => onChange('planType', 'yearly')} value="yearly" />
              }
              label={<Typography>
              Anual (<s style={{ fontSize: '15px'}}>R$ 1078,80</s>)&nbsp; <b>R$ 838,80</b> &nbsp;&nbsp;&nbsp;
            </Typography>}
              style={{
                margin: 'auto',
                border: '1px solid',
                borderColor: values.planType === 'yearly' ? '#537CCD' : '#CECECE',
              }}
            />
            <Typography variant="body2" style={{ fontSize: '13px', color: '#00B467', fontWeight: 'bold', position: 'absolute' }}>
              Desconto de 22% no plano Anual
            </Typography>
          </div>

        </div>
        {/* <Typography>cupom</Typography> */}
        <div style={{ paddingTop: '10px' }}>
          <TextField id="outlined-basic" label="Cupom" variant="outlined" />
          {/* <Button variant="contained" color="primary" style={{ marginLeft: '5px', height: '55px' }}>
            Ativar!
          </Button> */}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.checkboxStatus}
              onChange={() => onChange('checkboxStatus', !values.checkboxStatus)}
              value={values.checkboxStatus}
              color="primary"
            />
          }
        />
        <Typography variant="body1" style={{ marginLeft: '-16px' }}>
          Concordo com os <a style={{ color: '#537ccd', textDecoration: 'none' }} href="https://puntu.digital/terms.html" rel="noopener noreferrer" target="_blank">Termos e Condições de Uso</a> do Puntu
        </Typography>
      </div>
    </Typography >
  );
}

export default PaymentModalContent;
